export default "__VITE_ASSET__2cde9d30__"